import PropTypes from 'prop-types';

import { assetType } from '.';

export const tiktokType = PropTypes.shape({
  assets: PropTypes.arrayOf(assetType).isRequired,
  caption: PropTypes.string.isRequired,
  comments: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
  createdAtAgo: PropTypes.string.isRequired,
  creator: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  displayName: PropTypes.string.isRequired,
  engagementCount: PropTypes.number.isRequired,
  engagementRate: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  insight: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  likes: PropTypes.number.isRequired,
  shares: PropTypes.number.isRequired,
  updatedAt: PropTypes.string.isRequired,
  updatedAtAgo: PropTypes.string.isRequired,
  videoViews: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
});

export const tiktokInsightType = PropTypes.shape({
  creator: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  followersCount: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  profileImage: PropTypes.string.isRequired,
});
